<template>

   <spinner v-if="!loaded" ></spinner>

    <div class="container pt-3" v-else-if="loaded"  > 
        
        <!-- ONBOARDING WELCOME -->
        <div class="row no-gutters mt-5 text-center" v-if="step == 0" >
            <div class="col-12 mt-4" > 
                
                <div class="col-12 col-md-4 offset-md-4 mb-5" >
                    <img src="@/assets/images/welcome.png"  class="col-12" /> 
                </div>
                
                <h1> Thank you for joining Atlass </h1>
                
                <div class="col-12 text-center mt-5" >
                    <button class="btn btn-primary d-none" @click="NextStep()" > Start </button>
                    <router-link :to="{name: 'Academy'}" class="btn btn-primary btn-lg" > Start Learning </router-link> 
                </div>
                
                <div class="col-12 text-center mt-5 alert alert-dark" >
                    
                    <div class="col-12 section-title mt-md-5">

                        <h1 class="text-center text-700 heading3 font-primary"> FREE 1-on-1 Strategy Call  with our Team </h1>
                        
                        <p class="mt-4 color-white text font-size-16">                                
                            Hop on a FREE call with one of our Specialists to kick off your training. 
                            <br>
                            We’ll learn a little bit more about you and your business so you can get the most out of this training and learn how to get RESULTS.
                        </p>

                    </div>
                    
                    <a href="https://theatlass.com/book-a-call.html" class="btn btn-primary btn-lg mt-5 mb-4" target="_blank" > Book Your Call </a> 
                    
                </div>
                
            </div>
        </div>
        <!-- ONBOARDING WELCOME -->
        
        <div class="row no-gutters mt-5 text-center" v-if="step == 1" >
            <div class="col-12" > 

                <h1> What kind of business funnel do you have? </h1>
                                
                <div class="col-12 text-center" >
                    <button class="btn btn-primary d-none" @click="NextStep()" > Next </button>
                    <router-link :to="{name: 'Academy'}" class="btn btn-primary" > Start Learning </router-link> 
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'  
import helper from '@/helpers/helpers.js';

export default {
    name: 'Onboarding',
    components:{
        
    },
    props: {
    },
    data: function(){
        return {
            loaded: false,
            data:{},
            step: 0,
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        
        //this.get_data();
        
        let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
        this.data.organizationID = orgID;
        
        setTimeout(function(){ this.loaded = true }.bind(this), 100 );
        
    },
    beforeDestroy() {
    },
    methods: {
         get_data(){
          
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            //console.log( user )
                        
            const db = firebase.firestore();
            var ref = db.collection('users').doc( user.userID )
            
            return ref.get()
                .then((snapshot) => {
                    console.log(snapshot.data())
                    this.data = snapshot.data()
                    this.data.id = snapshot.id
                    this.loaded = true;
                })
          
        },
        NextStep(){
            
            this.step++
                        
            let params = Cookies.get('user-token')
            
            let data = JSON.stringify({
                "step":  this.step,
            } )
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/user/onboarding.php', headers: { 'Content-Type': 'text/plain', "X-Auth": params }, data: data })
                .then(resp => {

                let r = resp.data;

                if( r.status == 100 ){
                    console.log( r.message[0] );

                    this.loaded = true;
                    
                }else if( r.status == 101 ){
                    // if resp is unauthorized, logout, to
                    this.$store.dispatch(AUTH_LOGOUT).then(() => { 
                        this.$router.push({ name: 'Login'});
                    })
                }
                
            }); //end axios  
            
        },
        previousStep(){
            
            this.step--            
            
            let params = Cookies.get('user-token')
            
            let data = JSON.stringify({
                "step":  this.step,
            } )
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/user/onboarding.php', headers: { 'Content-Type': 'text/plain', "X-Auth": params }, data: data })
                .then(resp => {

                let r = resp.data;

                if( r.status == 100 ){
                    console.log( r.message[0] );

                    this.loaded = true;
                    
                }else if( r.status == 101 ){
                    // if resp is unauthorized, logout, to
                    this.$store.dispatch(AUTH_LOGOUT).then(() => { 
                        this.$router.push({ name: 'Login'});
                    })
                }
                
            }); //end axios  
            
        },
        Done(){
            
            let params = Cookies.get('user-token')
            
            let data = JSON.stringify({
                "step":  0,
            } )
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/user/onboarding.php', headers: { 'Content-Type': 'text/plain', "X-Auth": params }, data: data })
                .then(resp => {

                let r = resp.data;

                if( r.status == 100 ){
                    console.log( r.message[0] );

                    this.$router.push({ name: 'Home'});

                    this.loaded = true;
                    
                }else if( r.status == 101 ){
                    // if resp is unauthorized, logout, to
                    this.$store.dispatch(AUTH_LOGOUT).then(() => { 
                        this.$router.push({ name: 'Login'});
                    })
                }
                
            }); //end axios  
                        
        }
    },
    watch: {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
    .pricing .col{
        margin-left: 5px;
    }
    .pricing .col:first-of-type{
        margin-left: 0;
    }
    
</style>



// WEBPACK FOOTER //
// src/templates/setup/Onboarding.vue